/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFolderZip = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M12.618 6H22v16H2V2h8.618zM4 20h16V8h-3v2h1v1h-1v1h1v1h-1v1h1v1h-1v1h1v1h-1v1h-2v-2h-1v-1h1v-1h-1v-1h1v-1h-1v-1h1v-1h-1V9h1V8h-3.618l-2-4H4z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFolderZip as FolderZip };
